/**
 * POST Company
 */
import * as _ from 'lodash-es';
import { Dispatch } from 'redux';
import { track } from '../../analytics/analytics';

import {
  ACTION_POST_CREDITCARD,
  ACTION_POST_CREDITCARD_SUCCESS,
  ACTION_POST_CREDITCARD_FAILURE,
  ACTION_RESET_CREDITCARD,
  API_CALL,
} from '../../configs/ActionTypes';

import { enqueueSnackbarHandler } from '../Status';

/**
 * POST Users Request Action
 */
export function add(data: any) {
  return (dispatch: Dispatch, getState: Function) => {
    dispatch(requestStarted());

    //Dispatch the api call request.
    dispatch({
      type: API_CALL,
      payload: {
        call: 'creditCards',
        method: 'post',
        data: JSON.stringify(data),
        success: (response: object) => {
          dispatch(requestSuccess(response));
          enqueueSnackbarHandler(
            dispatch,
            { addCreditCardSuccess: true },
            'success',
          );
          handleTrack(data);
        },
        fail: (error: any) => {
          dispatch(requestFailed(error));
          enqueueSnackbarHandler(dispatch, error.payload, 'error');
        },
      },
    });

    return null;
  };
}

export function requestStarted() {
  return {
    type: ACTION_POST_CREDITCARD,
    payload: null,
  };
}

function requestSuccess(responeJSON: object) {
  return {
    type: ACTION_POST_CREDITCARD_SUCCESS,
    payload: responeJSON,
  };
}

function requestFailed(responeJSON: object) {
  return {
    type: ACTION_POST_CREDITCARD_FAILURE,
    payload: responeJSON,
  };
}

export function resetAddCreditCard() {
  return (dispatch: Dispatch, getState: Function) => {
    dispatch({
      type: ACTION_RESET_CREDITCARD,
      payload: null,
    });
  };
}

function handleTrack(data: any) {
  if (data.organizationId !== undefined) {
    if (data.departmentIds.length > 0) {
      track('BB_CreditCardCreated', { Type: 'department' });
    } else {
      track('BB_CreditCardCreated', { Type: 'company' });
    }
  } else if (data.userId !== undefined) {
    track('BB_CreditCardCreated', { Type: 'personal' });
  }
}
